module.exports = __webpack_public_path__ + "static/site-icon-fae3faa93af32f9f76da698731a0d6a7.png";